<template>
  <label :id="'label-' + nameInput" :for="nameInput" :class="{'form-input-error': !msg.state, 'form-input': msg.state}">
    <input class="input-default-style font-medium font-weight-400"
           :type="dataType"
           :id="nameInput"
           placeholder="&nbsp;"
           :value="data"
           @input="$emit('update:data', $event.target.value)">
    <span class="label">{{ placeholder }}</span>
    <span class="error-color font-small" v-if="!msg.state">{{ $t(msg.message) }}</span>
  </label>


</template>

<script lang="ts">
import './input.scss';
import {defineComponent} from "vue";
import type {PropType} from "vue";

interface Message {
  state: Boolean,
  message: String
}


export default defineComponent({
  name: 'inputComponent',
  props: {
    data: [String, Number],
    nameInput: {
      type: String,
    },
    placeholder: {
      type: String
    },
    dataType: {
      type: String
    },
    msg: {
      type: Object as PropType<Message>,
      default: {state: true, message: ''},
      required: false,
    }
  },
  emits: ['update:data'],
  data() {
    return {
    }
  },

})
</script>

<style scoped>

</style>